// Helper functions for appliance downloads
import { getSessionVar } from '../../../../lib/helpers';
import { CLOUD_TYPE } from '../../../../constants';

const APPLIANCE_BASE_URL = () => {
    return getSessionVar('repo_urls')?.appliances || '';
};

/**
 * Get the migration engine version from session storage
 * @returns {string} The migration engine version
 */
export const getApplianceLatestVersionVersion = () => {
    return getSessionVar('applianceLatestVersion') || 'latest';
};

/**
 * Get appliance download URL for a given cloud type
 * @param {string} cloudType - The cloud type (rivermeadow_standalone, openshift, nc2, hpe_vme, hyperv)
 * @returns {string} The download URL
 */
export const getApplianceDownloadUrl = (cloudType) => {
    const version = getApplianceLatestVersionVersion();

    const urlMap = {
        rivermeadow_standalone: `${APPLIANCE_BASE_URL()}/rms-ma-vsphere-${version}.zip`,
        openshift: `${APPLIANCE_BASE_URL()}/rms-ma-openshift-${version}.zip`,
        openstack: `${APPLIANCE_BASE_URL()}/rms-ma-openstack-${version}.zip`,
        nc2: `${APPLIANCE_BASE_URL()}/rms-ma-nc2-${version}.zip`,
        hpe_vme: `${APPLIANCE_BASE_URL()}/rms-ma-hpe-vme-${version}.zip`,
        hyperv: `${APPLIANCE_BASE_URL()}/rms-ma-hyperv-${version}.zip`,
    };

    return urlMap[cloudType] || null;
};

/**
 * Get the label for token/configuration based on cloud type
 * @param {string} cloudType - The cloud type
 * @returns {string} The label
 */
export const getTokenLabel = (cloudType) => {
    const labelMap = {
        rivermeadow_standalone: 'token',
        openshift: 'ConfigMap',
        openstack: 'Customization Script',
        nc2: 'Custom Script',
        hpe_vme: 'Customization Script',
        hyperv: 'Customization Script',
    };

    return labelMap[cloudType] || 'token';
};

/**
 * Check if cloud type uses configuration data instead of token
 * @param {string} cloudType - The cloud type
 * @returns {boolean} True if uses configuration data
 */
export const usesConfigurationData = (cloudType) => {
    return [CLOUD_TYPE.OPENSHIFT, CLOUD_TYPE.OPENSTACK, CLOUD_TYPE.NC2, CLOUD_TYPE.HPE_VME, CLOUD_TYPE.HYPERV].includes(
        cloudType,
    );
};

/**
 * Get the OpenShift Service Policy YAML template
 * @returns {string} The Service Policy YAML content
 */
export const getOpenShiftServicePolicyYAML = () => {
    return `apiVersion: v1
kind: Service
metadata:
  name: <Service Policy Name>
  namespace: migration-tests
  annotations:
    service.beta.kubernetes.io/aws-load-balancer-internal: 'true'
    service.beta.kubernetes.io/aws-load-balancer-type: nlb
spec:
  type: LoadBalancer
  selector:
    vm.kubevirt.io/name: <Rivermeadow Migration Appliance VM Name>
  ports:
    - protocol: TCP
      port: 8888
      targetPort: 8888`;
};
